<app-portal-navigation
  [portalName]="portalName"
  [portalIcon]="portalIcon"
  [portalClass]="portalClass"
  collapseId="profileMenu"
  [firstName]="userProfile?.firstName ?? ''"
  [lastName]="userProfile?.lastName ?? ''"
  [primaryItems]="primaryNavigationItems"
  [profileRoute]="profileRoute"
  [additionalItems]="additionalNavigationItems"
  [clinicMemberships]="clinicMemberships"
  (switchClinic)="onSwitchClinic($event)"
>
</app-portal-navigation>

<div class="container-fluid p-3 p-md-4" style="max-width: 1400px">
  <!-- Hero Banner -->
  <div class="booking-hero card border-0 mb-4">
    <div class="booking-hero__content">
      <div>
        <div class="booking-hero__eyebrow">Account & Organization</div>
        <h2 class="booking-hero__title mb-1">Profile Management</h2>
        <div class="booking-hero__meta">
          <span
            ><i class="bi bi-person-gear me-1 text-primary"></i>Manage your personal information and
            practice location settings</span
          >
        </div>
      </div>
    </div>
  </div>

  <div class="card booking-card">
    <div class="card-body p-0">
      <div class="row g-0">
        <!-- Sidebar Tabs -->
        <div class="col-lg-3 border-end bg-light">
          <div class="list-group list-group-flush settings-tabs p-3">
            <button
              class="list-group-item list-group-item-action mb-2 rounded-3"
              [class.active]="activeTab === 'personal'"
              (click)="setActiveTab('personal')"
            >
              <i class="bi bi-person-circle me-2"></i>
              Personal Profile
            </button>

            @if (clinicMemberships.length > 0) {
              <button
                class="list-group-item list-group-item-action rounded-3"
                [class.active]="activeTab === 'clinic'"
                (click)="setActiveTab('clinic')"
              >
                <i class="bi bi-building me-2"></i>
                Practice Profile
              </button>
            }
          </div>
        </div>

        <!-- Settings Content -->
        <div class="col-lg-9">
          <div class="p-3 p-md-4">
            @switch (activeTab) {
              @case ('personal') {
                <app-personal-profile></app-personal-profile>
              }
              @case ('clinic') {
                <app-clinic-profile></app-clinic-profile>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
